import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { IBaseSearchRequest, IPagedResults } from 'src/app/core/models/base';
import { environment } from 'src/environments/environment';
import { IContact, ICreateContactRequest, IUpdateContactRequest } from '../models/contact';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  constructor(private http: HttpClient) { }

  getContact(id: string){
    return this.http.get<IContact>(
      `${environment.baseUrl}/v1/contact/getContact/${id}`
    )
  }

  listContacts(request: IBaseSearchRequest){
    return this.http.post<IPagedResults<IContact[]>>(
      `${environment.baseUrl}/v1/contact/searchcontacts`,
      request
    ).pipe(
      map(data => {
        const response = data;

        response.data.map(contact => {
          const contactObj = contact;
          contactObj.fullName = contact.isCompany ? contact.companyName : `${contact.firstName} ${contact.lastName}`
          return contactObj
        })

        return response;
      
      }))
  }

  addContact(request : ICreateContactRequest){
    return this.http.post<string>(
      `${environment.baseUrl}/v1/contact/createcontact`,
      request
    )
  }

  updateContact(request : IUpdateContactRequest){
    return this.http.put<string>(
      `${environment.baseUrl}/v1/contact/updatecontact/${request.id}`,
      request
    )
  }

  deleteContact(id :string){
    return this.http.delete(
      `${environment.baseUrl}/v1/contact/deletecontact/${id}`
    )
  }
}
